"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IneligibleForRefund = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var copy_1 = require("../../../../copy");
var IneligibleForRefund = function (_a) {
    var message = _a.message, heading = _a.heading;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    var Heading1 = (0, core_1.useComponents)().Heading1;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Heading1, null, heading || react_1.default.createElement(Copy, { copyKey: "ineligibleHeading" })),
        message));
};
exports.IneligibleForRefund = IneligibleForRefund;
